import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { openShipmentItemsEditPopup, setShipmentItemsEditPopupData } from './shipmentItemsSlice'
import { selectShipment } from '../shipmentSlice'
import { STANDARD_PACKAGE_TYPE } from '../../../data/static-data'

import linkStyle from "../../../sass/custom/link.module.scss"
import { useTranslation } from 'react-i18next'

const ShipmentItemTableRow = ({index, data, boxID}) => {
    const {i18n} = useTranslation()
    const dispatch = useDispatch()
    const shipment = useSelector(selectShipment)

    const displayWidth = window.innerWidth

    const handleTrNameClick = () => {
        dispatch(setShipmentItemsEditPopupData({
            data: data
        }))
        dispatch(openShipmentItemsEditPopup({
            boxID: boxID
        }))
    }

  return (
        <tr>
            <td>
                <div className="inline-flex flex-col gap-0.5">
                    <span 
                        onClick={handleTrNameClick}
                    >{index}</span>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5">
                    <span 
                        className='text-emerald-600 cursor-pointer break-all'
                        onClick={handleTrNameClick}
                    >{data["original-name"] ? data["original-name"].slice(0, 20) + "..." : ""}</span>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5">
                    <span>
                        {data["value-for-one"]} ₺
                    </span>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5">
                    <span>{data["count"]}</span>
                </div>
            </td>
            {shipment && shipment["package-type"] === STANDARD_PACKAGE_TYPE && (
                <td className="hidden sm:table-cell">
                    <div
                        style={{
                            margin: "0 auto",
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden"
                        }}
                    >
                        <a 
                            className="cursor-pointer text-emerald-600" 
                            target="_blank"  
                            href={data["link"]}
                            rel="noreferrer"
                        >
                            {data["link"]}
                        </a>
                    </div>
                </td>
            )}
            <td className="hidden sm:table-cell">
                <div className="inline-flex flex-col gap-0.5">
                    <span>{data["warning"] ? 
                        <>
                            <img 
                                src="/static/images/png/green_circle_checkmark.png" alt="" 
                                width={displayWidth < 520 ? 10 : 15} 
                                height={displayWidth < 520 ? 10 : 15}
                            />
                        </> : 
                        <>
                            {/* <img 
                                src="/static/images/png/red_stop_sign.png" alt="" 
                                width={displayWidth < 520 ? 10 : 15} 
                                height={displayWidth < 520 ? 10 : 15}
                            /> */}
                        ⚪
                        </>}
                    </span>
                </div>
            </td>
        </tr>
  )
}

export default ShipmentItemTableRow